import RereservationPage from "@/public/components/features/rereservation/RereservationPage"

const Rereservation = () => {
	return <RereservationPage />
}

export default Rereservation
